import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-page-hero',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './page-hero.component.html',
  styleUrl: './page-hero.component.scss',
})
export class PageHeroComponent {
  @Input() icone = '';
  @Input() iconeSrc = '';
  @Input() titulo = '';
  @Input() subtitulo = '';
  @Input() badge: string | number | null = null;
}
